var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customize_page_management" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tips", staticStyle: { "margin-top": "20px" } },
        [
          _vm._v(
            "克隆的系统默认模板不能直接拿去上架安卓或苹果应用商店。一定要自己重新设计和调整一下，不然上架会被拒绝。"
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          { staticStyle: { width: "400px" } },
          [
            _c("el-input", {
              attrs: { placeholder: "输入模板名称查询", clearable: "" },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex", staticStyle: { width: "fit-content" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.search()
                  },
                },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                attrs: { type: "info", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.reset()
                  },
                },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-circle-plus-outline", type: "success" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新建模板")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
                data: _vm.tableList,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "模板ID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.pageId))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "模板名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.name))]),
                        _c("br"),
                        _vm._v(" "),
                        scope.row.status === 3
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  background: "#E6A23C",
                                  "font-size": "12px",
                                  color: "#fff",
                                  display: "inline-block",
                                  "border-radius": "20px",
                                  padding: "0  5px",
                                  "line-height": "20px",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.statusDesc))]
                            )
                          : scope.row.status === 2
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  background: "#67C23A",
                                  "font-size": "12px",
                                  color: "#fff",
                                  display: "inline-block",
                                  "border-radius": "20px",
                                  padding: "0  5px",
                                  "line-height": "20px",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.statusDesc))]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "最后更新" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创建时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "right",
                  width: "",
                  label: "扩展操作",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goRenovation(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              页面装修\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clone(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              克隆模板\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  fixed: "right",
                  width: "",
                  label: "操作",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "10px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.detail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              编辑\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pagination-container",
              staticStyle: { margin: "20px 0", "text-align": "right" },
            },
            [
              _c("el-pagination", {
                staticStyle: { display: "inline-block" },
                attrs: {
                  "current-page": _vm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.size,
                  total: _vm.total,
                  background: "",
                  layout: "total, prev, pager, next, sizes,jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("addPop", {
        ref: "addPop",
        attrs: { "page-type": 1 },
        on: { refresh: _vm.onRefresh },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card frb" }, [
      _c("div", { staticClass: "flex" }, [_vm._v("首页装修-模板管理")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }